import { lang } from '@sc/data-access-models';

// Mapping between each supported language and their displayed name
export const languageDisplayMapping: Record<lang, string> = {
  fr_FR: 'Français',
  en_GB: 'English',
  en_US: 'American',
  es_ES: 'Español',
  pt_BR: 'Brasileiro',
  et_EE: 'Eest keel',
  fi_FI: 'Suomi',
  el_GR: 'Ελληνικά',
  it_IT: 'Italiano',
  lt_LT: 'Lietuvių',
  nb_NO: 'Norsk',
  pt_PT: 'Português',
  ru_RU: 'Pусский',
  de_DE: 'Deutsch',
  hu_HU: 'Magyar',
  nl_NL: 'Nederlands',
};
